import React from 'react';
import {Trans} from 'gatsby-plugin-react-i18next';
import {MenuLink} from '../utils/types';

export const ecommerceItems: MenuLink[] = [
  {
    icon: 'e-commerce',
    slug: 'online-payments',
    title: <Trans>E-commerce payments</Trans>
  },
  {
    icon: 'laptop',
    slug: 'saas-payment-gateway',
    title: <Trans>Software Solutions</Trans>
  },
  {icon: 'marketplace', slug: 'connect', title: <Trans>Marketplaces</Trans>},
  {
    icon: 'government',
    slug: 'public-administrations-payment-platform',
    title: <Trans>Public Administration</Trans>
  },
  {
    icon: 'graduation-cap',
    slug: 'payment-gateway-elearning',
    title: <Trans>E-learning Hubs</Trans>
  }
];

export const retailInStoreItems: MenuLink[] = [
  {
    icon: 'restaurant',
    slug: 'monei-pay/qr-code-payment-restaurant',
    title: <Trans>Hospitality</Trans>
  },
  {
    icon: 'scissors',
    slug: 'monei-pay/pos-systems-for-hair-salon',
    title: <Trans>Hair & Beauty Salons</Trans>
  },
  {icon: 'taxi', slug: 'monei-pay/pos-systems-for-taxis', title: <Trans>Taxi Payments</Trans>},
  {
    icon: 'food-truck',
    slug: 'monei-pay/food-truck-pos-system',
    title: <Trans>Food Trucks</Trans>
  }
];

export const freelancersItems: MenuLink[] = [
  {
    icon: 'freelancer',
    slug: 'monei-pay/pos-for-freelancers',
    title: <Trans>Freelancers</Trans>
  },
  {
    icon: 'dentist',
    slug: 'monei-pay/accept-payments-dental-practice',
    title: <Trans>Health Providers</Trans>
  },
  {
    icon: 'legal',
    slug: 'monei-pay/legal-billing-software',
    title: <Trans>Law Firms</Trans>
  }
];
